import styles from '../DatePicker.module.css';

import type { CalendarDayCellProps } from '../types/internal.types';

const joinClassName = (className: string | undefined, stateClassNames: string[]): string =>
  [styles.cell, ...stateClassNames, className ?? ''].filter(Boolean).join(' ');

const joinButtonClassName = (className: string | undefined, stateClassNames: string[]): string =>
  [styles.dayButton, ...stateClassNames, className ?? ''].filter(Boolean).join(' ');

export default function CalendarDayCell({
  children,
  className,
  dayButtonProps,
  focused = false,
  outsideMonth = false,
  selected = false,
  unavailable = false,
  ...rest
}: CalendarDayCellProps) {
  const cellStateClassNames = [];
  const buttonStateClassNames = [];
  const ariaDisabled = dayButtonProps['aria-disabled'] ?? (unavailable || undefined);

  if (focused) {
    buttonStateClassNames.push(styles.focused);
  }

  if (selected) {
    buttonStateClassNames.push(styles.selected);
  }

  if (unavailable) {
    cellStateClassNames.push(styles.disabled);
    buttonStateClassNames.push(styles.disabled);
  }

  if (outsideMonth) {
    cellStateClassNames.push(styles.outsideMonth);
    buttonStateClassNames.push(styles.outsideMonth);
  }

  return (
    <td
      {...rest}
      aria-selected={selected || undefined}
      className={joinClassName(className, cellStateClassNames)}
      data-focused={focused || undefined}
      data-outside-month={outsideMonth || undefined}
      data-selected={selected || undefined}
      data-unavailable={unavailable || undefined}
      role="gridcell"
    >
      <button
        {...dayButtonProps}
        aria-disabled={ariaDisabled}
        className={joinButtonClassName(dayButtonProps.className, buttonStateClassNames)}
        disabled={dayButtonProps.disabled ?? unavailable}
        ref={dayButtonProps.ref}
        tabIndex={dayButtonProps.tabIndex ?? (focused ? 0 : -1)}
        type={dayButtonProps.type ?? 'button'}
      >
        {children}
      </button>
    </td>
  );
}
